import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import portada from "../assets/portada.png";
import misionVision from "../assets/nosotros-1.jpg";
import misionVision2 from "../assets/nosotros-2.jpg";
import misionVision3 from "../assets/nosotros-3.jpg";
import misionVision4 from "../assets/nosotros-4.jpg";
import cart from "../assets/cart.png";
import Whatsapp from "../assets/Whatsapp.svg"
import { useTitle } from "../hooks/useTitle";

import { useState, useEffect } from "react";
import CarritoCompras from "../components/CarritoCompras";
import { Swiper, SwiperSlide } from 'swiper/react';
import { useLocation } from "react-router-dom";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
// import required modules
import { Pagination } from 'swiper/modules';
import { Helmet } from "react-helmet-async";
import { useAuth } from "../hooks/useAuth";

const Nosotros = () => {
    
    const { pathname }  = useLocation()
    
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    const { usuario } = useAuth();
    const [openCart, setOpenCart] = useState(false);
    const title = `Nosotros`;
    // useTitle({ title });
    return (
        <>
            <Helmet prioritizeSeoTags={true}>
                <title>{`${title} | Bicicletas java colombia`}</title>
                <meta property="og:type" content="website" />
                <meta property="og:title" content={`${title} | Bicicletas java colombia`} />
                <meta property="og:url" content="https://bicicletasjavacolombia.com/" />
                <meta property="og:image" content="https://bicicletasjavacolombia.com/src/assets/logo-footer.png" />
                <meta property="og:description" content={`mision: Ser líderes globales en la industria del ciclismo, reconocidos por la calidad, innovación y diseño de nuestras bicicletas, fomentando una comunidad apasionada por el ciclismo y el respeto al medio ambiente. Aspiramos a inspirar a ciclistas de todas las edades y niveles a alcanzar nuevas metas y descubrir el mundo desde dos ruedas. Vision: Ofrecer bicicletas de alta calidad que combinan diseño innovador, tecnología avanzada y durabilidad. Promovemos el ciclismo como un estilo de vida saludable, sostenible y accesible, apoyando a nuestros clientes en cada pedalada de su viaje, mientras preservamos nuestra pasión y compromiso con la excelencia en cada modelo que producimos.`} />
            </Helmet>
            <div className="wrapper" style={{ maxWidth: "100%", background: "#000000" }}>
                <Header setOpenCart={setOpenCart} openCart={openCart} />
                <CarritoCompras setOpenCart={setOpenCart} openCart={openCart} />
                <div className="banner-productos">
                    <div className="portada">
                        <img src={portada} />
                        <p>Nosotros</p>
                    </div>
                </div>
                <div className="wrapper" style={{ display: "flex", flexDirection: "row", marginTop: 50, marginBottom: 50 }}>
                    <div className="mision-vision">
                        <div style={{ marginBottom: 50, paddingRight: 20 }}>
                            <h2>Mision</h2>
                            <p style={{ fontSize: 20 }}>Ser referentes en Colombia en la industria de las bicicletas, reconocidos por nuestra calidad, innovación y diseño. Buscamos fomentar una comunidad apasionada por el uso de bicicletas y comprometida con el respeto al medio ambiente. Aspiramos a inspirar a personas de todas las edades y niveles a alcanzar nuevas metas y explorar el mundo sobre dos ruedas.</p>
                        </div>
                        <div style={{ marginBottom: 50, marginRight: 20, paddingRight: 20 ,width: "90%"}} className="border-mex-full"></div>
                        <div style={{ paddingRight: 20 }}>
                            <h2>Vision</h2>
                            <p style={{ fontSize: 20 }}>Ofrecer bicicletas de alta calidad que combinan diseño innovador, tecnología avanzada y durabilidad. Promovemos el ciclismo como un estilo de vida saludable, sostenible y accesible, apoyando a nuestros clientes en cada pedalada de su viaje, mientras preservamos nuestra pasión y compromiso con la excelencia en cada modelo que producimos.</p>
                        </div>
                    </div>
                    <div className="mision-img">
                        <img src={misionVision} />
                    </div>
                </div>
                <div className="wrapper" style={{ textAlign: "center" }}>
                    <h1 className="nosotros-h1">Valores que nos conectan</h1>
                    <p style={{ fontSize: 20 }}>Cumplir con el trabajo diario es nuestra pasión y la felicidad de los clientes nuestra mayor satisfacción como empresa.</p>
                    <div className="container-card-nosotros">
                        <div className="card-nosotros" >
                            <h2>PERSONAS</h2>
                            <p>
                                Creemos que el ciclismo conecta a las personas y fomenta comunidades más fuertes.
                                Valoramos el bienestar de nuestros colaboradores, clientes y ciclistas, promoviendo
                                un ambiente inclusivo y de apoyo.
                            </p>
                            <div className="border-mex-full" style={{width: "100%", marginTop: "10px"}}></div>
                        </div>
                        <div className="card-nosotros">
                            <h2>COMPROMISO</h2>
                            <p>
                            Nos esforzamos para cumplir con cada detalle, requerimiento
                            y necesidad de nuestros clientes. No es vender bicicletas, es entregar la
                            bicicleta que corresponda y que se ajuste a las necesidades de nuestros
                            clientes.
                            </p>
                            <div className="border-mex-full" style={{width: "100%", marginTop: "10px"}}></div>
                        </div>
                        <div className="card-nosotros">
                            <h2>PASIÓN</h2>
                            <p>
                            Es el motor que impulsa cada decisión que
                            tomamos. Pasión por lo que hacemos, nos fijamos en cada detalle, desde el
                            proceso de importación, hasta la entrega final de las bicicletas a nuestros
                            clientes, logrando que nuestros clientes reciban lo que quieren, necesitan y
                            en los términos pactados.

                            </p>
                            <div className="border-mex-full" style={{width: "100%", marginTop: "10px"}}></div>
                        </div>
                        <div className="card-nosotros">
                            <h2>EL CLIENTE</h2>
                            <p>
                            Escuchamos, entendemos y valoramos las necesidades de nuestros
                            clientes. Ellos son el centro de todo lo que hacemos, y nuestro objetivo es
                            superar sus expectativas en calidad, servicio y experiencia.

                            </p>
                            <div className="border-mex-full" style={{width: "100%", marginTop: "10px"}}></div>
                        </div>
                    </div>
                </div>
                <div className="wrapper">
                    <div className="gallery">
                        <Swiper loop={true} pagination={{ clickable: true }} modules={[Pagination]} slidesPerView={1}
                            breakpoints={{
                                640: {
                                    slidesPerView: 1
                                },
                                768: {
                                    slidesPerView: 2
                                },
                                1024: {
                                    slidesPerView: 2
                                },
                                1150: {
                                    slidesPerView: 3
                                }
                            }}
                            spaceBetween={30}>
                            <SwiperSlide>
                                <img src={misionVision} />
                            </SwiperSlide>

                            <SwiperSlide>
                                <img src={misionVision2} />
                            </SwiperSlide>

                            <SwiperSlide>
                                <img src={misionVision3} />
                            </SwiperSlide>

                            <SwiperSlide>
                                <img src={misionVision4} />
                            </SwiperSlide>

                        </Swiper>
                    </div>

                </div>
                <Footer />

                {usuario && <a onClick={() => setOpenCart(true)} className="float  carrito-button" target="_blank">
                    <img src={cart} width={24} />
                </a>}
                <a href="https://api.whatsapp.com/send/?phone=573107336975&text=Hola, me gustaria obtener más información acerca de los productos&type=phone_number&app_absent=0" className="float" target="_blank">
                    <img src={Whatsapp} width={24} />
                </a>
            </div>

        </>
    );
}

export default Nosotros;
